'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronDown, FaLock } from 'react-icons/fa'
import Modal from '../../component/Modal'
import { useAuth } from '../../contexts/AuthContext'
import { BsChatDotsFill } from 'react-icons/bs'

const ChatLandingBottomHalf = dynamic(() => import('./ChatLandingBottomHalf'), {
  ssr: false,
})

const PornLanding = () => {
  const { t } = useTranslation()

  const { user } = useAuth()
  const router = useRouter()
  const [welcomeModal, setWelcomeModal] = useState(false)
  const [upgradeModal, setUpgradeModal] = useState(false)
  const [safeWarningOpen, setSafeWarningOpen] = useState(false)

  const videoRef = useRef(null)

  useEffect(() => {
    if (user) {
      router.push('/explore')
    }
  }, [user])

  useEffect(() => {
    const playVideo = async () => {
      if (!videoRef.current) return
      try {
        await videoRef.current.play()
      } catch {}
    }

    playVideo()
  }, [])

  return (
    <div className="bg-[var(--background-bg-color)] min-h-screen">
      <Modal
        isOpen={welcomeModal}
        closeModal={() => setWelcomeModal(false)}
        title="Thanks for your patience 💜"
        content="Here is 100 Gems from the Promptchan team, enjoy!"
        confirmation="Claim Gems!"
        onConfirm={() => router.push('/signup')}
      />

      <Modal
        isOpen={upgradeModal}
        closeModal={() => setUpgradeModal(false)}
        title={
          <div className="flex items-center">
            <FaLock className="text-white opacity-70 z-20 mr-2" />
            <p>NSFW Content</p>
          </div>
        }
        content="You must sign up to view NSFW content."
        confirmation="Sign Up"
        onConfirm={() => router.push('/signup')}
      />

      <Modal
        isOpen={safeWarningOpen}
        closeModal={() => {
          setSafeWarningOpen(false)
        }}
        title={'Safe Mode Enabled'}
        content={
          <div>
            <p className="text-white">
              This feature may contain mature themes. Please disable Safe Mode
              in Settings for access.
            </p>
          </div>
        }
        confirmation="Settings"
        onConfirm={() => router.push('/settings')}
      />

      <div className="mx-auto w-full px-5 sm:px-0 sm:w-3/4 md:mt-14">
        <div className="min-h-screen">
          <div className="md:flex items-center justify-center space-x-3">
            <Link href="/signup" aria-label="Sign up for Promptchan">
              <div>
                <div className="flex justify-center">
                  <img src="/assets/chatLanding/chat-landing.webp" />
                </div>
              </div>
            </Link>

            <div className="md:w-2/3 mt-3">
              <h1 className="md:text-6xl text-4xl font-semibold tracking-tight text-white text-center md:mb-6 mb-2">
                NSFW AI Chat
              </h1>
              <h2 className="md:text-xl text-sm font-light tracking-tight text-gray-300 text-center mx-auto">
                Discover, Create & Chat with your Dream AI Character: Try the
                most lifelike AI Girlfriend experience available!
              </h2>

              <div className="md:mt-4 flex flex-col items-center justify-center rounded-xl">
                <Link href="/signup" aria-label="Sign up for Promptchan">
                  <div className="flex items-center justify-center px-6 w-72 max-w-full md:py-5 py-4 my-4 bg-gradient-to-r from-[#4f46e5] via-[#7F86FF] to-[#4f46e5] text-white rounded-3xl focus:outline-none ml-auto mr-auto font-semibold shadow-lg text-lg text-center transition-transform duration-200 hover:scale-[1.03] ">
                    <p style={{ textShadow: '2px 2px 28px rgba(0, 0, 0, 1)' }}>
                      {t('getStartedFor')}
                    </p>
                    <BsChatDotsFill className="ml-3 text-2xl" />
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <button
            className="transition-all duration-300 hover:scale-105 mx-auto flex mt-6 flex flex-col items-center"
            aria-label="Scroll down to learn more"
            onClick={() => {
              window.scrollBy({
                top: window.innerHeight, // Scrolls down by one viewport height
                behavior: 'smooth', // Ensures the scrolling is smooth
              })
            }}
          >
            <p className="text-gray-300 font-semibold text-sm mb-3">
              Learn More
            </p>

            <FaChevronDown className=" text-4xl text-gray-300 " />
          </button>
        </div>

        {/* Bottom half here */}
        <ChatLandingBottomHalf
          setSafeWarningOpen={setSafeWarningOpen}
          upgradeModal={upgradeModal}
          setUpgradeModal={setUpgradeModal}
        />
      </div>
    </div>
  )
}

export default PornLanding
